import { lazy } from 'react'

import { CheckIcon } from '@verbit-ai/icons-library'
import { useMediaRecorderContext } from '@verbit-ai/verbit-connect-web/recorder-provider'
import { useTheme } from '@chakra-ui/react'

const VolumeSlider = lazy(() => import('@verbit-ai/verbit-connect-web/recorder-volume-slider'))

import * as S from './styles'

export const TranscriptToolbarMicSelection = () => {
    const { audioInputDevices, selectedAudioInput, setSelectedAudioInput } = useMediaRecorderContext()
    const {
        palette: {
            toolbar: { extrasIconColor },
        },
    } = useTheme()

    return (
        <>
            {audioInputDevices.map((device) => (
                <S.MicOption key={device.deviceId} onClick={() => setSelectedAudioInput(device)}>
                    <S.MicOptionLabel>{device.label}</S.MicOptionLabel>
                    {device.deviceId === selectedAudioInput?.deviceId && <CheckIcon size={S.CHECK_ICON_SIZE} color={extrasIconColor} />}
                </S.MicOption>
            ))}
            <VolumeSlider />
        </>
    )
}
